import { Button, styled } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

export const InvitationAcceptanceViewport = styled('main')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: theme.spacing(4, 3),
  width: '100%',
}));

export const InvitationAcceptanceContent = styled('section')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: theme.spacing(90),
  textAlign: 'center',
  width: '100%',
}));

export const InvitationAcceptanceIcon = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

export const InvitationAcceptedIcon = styled(CheckCircleOutlineIcon)(
  ({ theme }) => ({
    color: theme.palette.success.main,
    fontSize: 50,
  }),
);

export const InvitationAcceptanceErrorIcon = styled(ErrorOutlineIcon)(
  ({ theme }) => ({
    color: theme.palette.error.main,
    fontSize: 50,
  }),
);

export const InvitationAcceptanceTitle = styled('h1')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: theme.typography.h5.fontFamily,
  fontSize: 24,
  fontWeight: Number(theme.typography.fontWeightBold),
  letterSpacing: theme.typography.h5.letterSpacing,
  lineHeight: '32px',
  margin: 0,
  marginBottom: theme.spacing(1),
}));

export const InvitationAcceptanceMessage = styled('p')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.body2.fontFamily,
  fontSize: theme.typography.body2.fontSize,
  letterSpacing: theme.typography.body2.letterSpacing,
  lineHeight: '22px',
  margin: 0,
}));

export const InvitationTeamName = styled('strong')(({ theme }) => ({
  fontWeight: Number(theme.typography.fontWeightBold),
}));

export const InvitationAcceptanceAction = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(2.25),
  marginTop: theme.spacing(2),
  minWidth: theme.spacing(10),
  padding: theme.spacing(0.625, 2),
}));
